import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'hs-text',
})

export default class HsText extends Vue {

    // ------------------------------------------------------------------
    // Properties

    @Prop()
    private content: any;

    @Prop()
    private showCorrect!: boolean;

    private get userAnswer() {
        const content = this.content;
        const userAnswer = content.userAnswer;
        return userAnswer;
    }

    private get question() {
        const question = this.content.resource;
        return question;
    }

    private get baseQuestions() {
        return this.question.answers;
    }

    // ----------------------------------------------------------------------------
    // Hooks

    // ------------------------------------------------------------------------------
    // Methods

    private isSelectedAnswer(answer: any) {
        const userAnswer = this.userAnswer.find((item: any) => item.id === answer.id);
        let className = userAnswer.selection ? 'correct' : '';
        if (this.showCorrect) {
            className = answer.isCorrect ? 'correct' : '';
        }
        return className;
    }


}
